import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function formularioComboReducer(state= initialState.formularioCombo, action){
	switch(action.type){
		case types.GET_FORMULARIOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}